module.exports = __webpack_public_path__ + "img/wheel-track-horizontal.60db4a6f.svg";